<script>
export default {
  translate25Context: "notification",
  props: ["component"],
  computed: {
    error() {
      return this.component.severity == 2;
    },
    warning() {
      return this.component.severity == 1;
    },
  },
  methods: {
    test(e) {
      console.log("evente");
      this.$emit("event", ["remove"]);
    },
  },
};
</script>
<template>
  <f-toast
    :class="{ error: error, warning: warning }"
    :icon="warning || error ? 'fa6-warning' : 'fa6-info'"
    v-on="$listeners"
  >
    <span v-if="component.html" v-html="component.html"></span>
    <template v-else>{{ $vt(component.label) }}</template>
    <template #action>
      <f-icon icon="fa6-close"></f-icon>
    </template>
  </f-toast>
</template>